import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { Order } from 'app/models/order/order';
import { OrderItem } from 'app/models/order/order-item';
import { ChangedPriceProduct } from 'app/models/product/changed-price-product/changed-price-product';
import { SimpleProduct } from 'app/models/product/product/simple-product';
import { DialogPriceChangedComponent } from 'app/pages/products/dialog-price-changed/dialog-price-changed.component';
import { Product } from 'app/pages/products/product';
import { CartService } from 'app/services/cart/cart.service';
import { OrderService } from 'app/services/order/order.service';
import { ProductService } from 'app/services/product/product.service';
import { PriceHelper } from 'app/shared/price-helper';
import { DialogChangeOrderComponent } from '../dialog-change-order/dialog-change-order.component';
import { MenuItem } from 'primeng/api/menuitem';
import { DocumentService } from 'app/services/document/document.service';
import { saveAs } from 'file-saver';
import { tap } from 'rxjs/internal/operators/tap';


@Component({
  selector: 'ultra-orders-list',
  templateUrl: './orders-list.component.html',
  styleUrls: ['./orders-list.component.scss'],
})
export class OrdersListComponent implements OnInit {

  orders: Order[] = [];
  selectedOrderId: number = null;
  documents: MenuItem[] = [
    { label: 'Boleto', command: () => this.downloadBankSlip() },
    { label: 'Nota Fiscal PDF', command: () => this.downloadIncome(true) },
    { label: 'Nota Fiscal XML', command: () => this.downloadIncome(false) },
  ];

  totalRecords: number;
  loading: boolean;
  downloadingDocument: boolean = false;

  constructor(
    private _orderService: OrderService,
    private dialogService: NbDialogService,
    private cartService: CartService,
    private router: Router,
    private priceHelper: PriceHelper,
    private _toastrService: NbToastrService,
    private _productService: ProductService,
    private documentService: DocumentService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.getOrders();
  }

  async getOrders(page?: number) {
    this.loading = true;
    page = page ? page : 1;

    await this._orderService.findAll(page).subscribe((value) => {
      this.orders = value.data.map(e => Order.fromJson(e));
      this.totalRecords = value.message;
    }, () => {
      this._toastrService.danger('Falha ao carregar os pedidos do usuário', 'Erro');
    }).add(() => this.loading = false);
  }

  keepBuying(order) {
    const arrayItens = JSON.parse(localStorage.getItem('cart'));
    if (arrayItens?.length > 0) {
      this.dialogService.open(DialogChangeOrderComponent, {
        context: {
          order: order,
        },
      }).onClose.subscribe((status) => {
        if (status)
          this.addProductsToCart(order);
      });
    } else {
      this.addProductsToCart(order);
    }
  }

  addProductsToCart(order: Order) {
    this.priceHelper.checkOrderPrices(order).then(data => {
      if (data && data.length > 0) {
        this.dialogService.open(DialogPriceChangedComponent, {
          context: {
            changedPrices: data,
          },
          closeOnBackdropClick: false,
          closeOnEsc: false,
        }).onClose.subscribe((changedItems: any[]) => {
          this.loadOrder(order, changedItems);
          this.router.navigate(['pages/products']);
        });
      } else {
        this.loadOrder(order);
        this.router.navigate(['pages/products']);
      }
    });
  }

  loadOrder(order: Order, data: ChangedPriceProduct[] = null) {
    order.items.map((el: OrderItem) => {
      // Ao zerar a quantidade, o produto é removido do carrinho
      if (data) {
        if (data.filter((changedItem: ChangedPriceProduct) => changedItem.orderItem.productId === el.productId && changedItem.orderItem.classificationId === el.classificationId && !changedItem.keep).length > 0) {
          el.quantity = 0;
        }
      }

      if (el.quantity > 0) {
        this._productService.getProductByIdAndClas(el.productId, el.classificationId).subscribe((data: any) => {
          var temp: Product = Product.fromJson(data.data);
          var simple: SimpleProduct = SimpleProduct.fromProduct(temp);
          simple.selectedQuantity = el.quantity;
          this.cartService.updateProduct(simple, temp.measurementUnits.find(e => e.measurementInitials == el.measurementUnitInitials), '=', el.quantity);
        });
      }

    });
    sessionStorage.setItem('selectedReceivingConditionId', order.receivingCondition.toString());
    sessionStorage.setItem('selectedPaymentReceiptFormId', order.paymentReceiptForm.toString());
    sessionStorage.setItem('currentOrder', JSON.stringify(order));
    this.router.navigate(['pages/products']);
  }

  getProductName(product: any): string {
    return product.classificationName != '' ? product.productName + ' - ' + product.classificationName : product.productName;
  }

  downloadBankSlip() {
    this.downloadingDocument = true;
    this.documentService.getBankSlip(this.selectedOrderId).pipe(
      tap((bankSlip) => {
        if (bankSlip.data == null)
          throw new Error('Boleto não encontrado')
      })
    ).subscribe((bankSlip) => {
      this.saveFile(bankSlip.data, `Boleto-${this.selectedOrderId}.pdf`);
      this.downloadingDocument = false;
    }, (error) => {
      const errorMessage = error.status == 400 ? 'Boleto não encontrado' : error.message ?? error.error.message;
      this._toastrService.danger(errorMessage, 'Erro ao fazer download do boleto');
      this.downloadingDocument = false;
    })
  }

  downloadIncome(pdf: boolean) {
    const observableIncome = pdf ? this.documentService.getIncomePDF(this.selectedOrderId) : this.documentService.getIncomeXML(this.selectedOrderId);

    this.downloadingDocument = true;
    observableIncome.pipe(
      tap((income) => {
        if (income.data == null)
          throw new Error('Nota fiscal não encontrada')
      })
    ).subscribe((income) => {
      this.saveFile(income.data, `Nota-Fiscal-${this.selectedOrderId}.${pdf ? 'pdf' : 'xml'}`);
      this.downloadingDocument = false;
    }, (error) => {
      const errorMessage = error.status == 400 ? 'Nota fiscal não encontrada' : error.message ?? error.error.message;
      this._toastrService.danger(errorMessage, `Erro ao fazer download da nota fiscal ${pdf ? 'PDF' : 'XML'}`);
      this.downloadingDocument = false;
    })
  }

  postOrder(order) {
    // if (this.cartService.cartProducts.length > 0) {
    //   this.dialogService.open(DialogChangeOrderComponent, {
    //     context: {
    //       order: order,
    //       okMessage: 'Continuar',
    //       cancelMessage: 'Cancelar',
    //       message: 'Existem produtos no carrinho. Caso continue, eles serão removidos. Deseja Continuar?',
    //       titleMessage: 'Finalizar Pedido',
    //     },
    //   }).onClose.subscribe(status => {
    //     if (status) {
    //       this.cartService.clearCart();
    //       this.loadOrder(order);
    //       this.router.navigate(['pages/checkout']);
    //     }
    //   });
    // } else {
    //   this.loadOrder(order);
    //   this.router.navigate(['pages/checkout']);
    // }
  }

  reloadData(event) {
    this.orders = [];
    this.getOrders(event.page + 1);
  }

  saveFile(encodedBase64: string, fileName: string) {
    var byteCharacters = atob(encodedBase64);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
      type: undefined
    });

    saveAs(blob, fileName);
  }
}
